import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/theme.css';
import './styles/modern.css';
import './styles/mobile.css';
import './styles/native.css';
// Yeni telefon tasarimi katmani. Butun kurallari ".yeni-tasarim" altinda;
// canli derlemede bu sinif hic eklenmedigi icin etkisiz (utils/yeniTasarim.js).
import './styles/mobil-arayuz.css';
import { initNativePlatform } from './utils/nativeInit';
import { YENI_TASARIM } from './utils/yeniTasarim';
import { altPencereyiBaslat } from './utils/altPencere';
import { hataKaydiniBaslat } from './utils/hataKaydi';

hataKaydiniBaslat();

if (YENI_TASARIM) {
  document.documentElement.classList.add('yeni-tasarim');
  altPencereyiBaslat();
}

// Tarayıcı sekmesi başlığını UTF-8 ile ayarla
document.title = 'Öztürk Hukuk ve Danışmanlık';

// Cache busting: Script tag'lerinden hash'i al (webpack otomatik hash ekler)
const getBuildHash = () => {
  // Script tag'lerini kontrol et
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].src;
    if (src && src.includes('/static/js/')) {
      // Hash'i çıkar (örn: main.abc123.js -> abc123)
      const match = src.match(/\/static\/js\/[^.]+\.([^.]+)\.js/);
      if (match && match[1]) {
        return match[1];
      }
    }
  }
  return null;
};

// Version kontrolü: Eğer yeni bir build varsa cache'i temizle ve sayfayı yenile
const checkVersion = () => {
  // DOM yüklenene kadar bekle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(checkVersion, 100); // Script tag'lerinin yüklenmesi için kısa bir bekleme
    });
    return;
  }
  
  const currentHash = getBuildHash();
  const storedHash = sessionStorage.getItem('app_build_hash');
  
  // Hash bulunamazsa (ilk yükleme veya development), devam et
  if (!currentHash) {
    return;
  }
  
  if (storedHash && storedHash !== currentHash) {
    // Yeni build bulundu, cache'i temizle
    console.log('Yeni build tespit edildi, sayfa yenileniyor...');
    
    /*
      LOCALSTORAGE ARTIK SILINMIYOR.

      Burada eskiden, yeni bir surum yayinlaninca localStorage'daki her
      anahtar -- kucuk bir "korunacaklar" listesi disinda -- siliniyordu.
      Listede personel oturumu vardi ama MUVEKKIL OTURUMU (muvekkilToken)
      ve FACE ID KAYDI (faceIdAcik) yoktu. Sonuc: her yayinda, telefon
      yeni surumu aldigi anda muvekkil disari atiliyor ve Face ID ayari
      kayboluyordu. "Her acilista sifre soruyor" sikayetinin asil sebebi
      buydu; 2026-09-30'da widget'a dokunulunca, 30 sn once yapilan bir
      yayin yuklendigi icin tekrarlandi (IIS kaydi: /muvekkil iki kez
      bastan yuklendi, ardindan giris; Face ID bayragi true -> false).

      Silinen hicbir anahtar sunucu verisi onbellegi degildi; hepsi
      kullanici durumu ve tercihiydi (oturum, Face ID, bildirim "goruldu"
      kayitlari, sutun tercihleri). Tarayici onbellegi de localStorage'da
      tutulmuyor. Yani silme hicbir sey kazandirmadan yalnizca zarar
      veriyordu. Yeni surumde sayfanin yenilenmesi aynen devam ediyor.
    */

    // SessionStorage'ı temizle
    sessionStorage.clear();
    
    // Hash'i güncelle
    sessionStorage.setItem('app_build_hash', currentHash);
    
    // Service Worker'ı unregister et (eğer varsa)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      });
    }
    
    // Sayfayı yenile
    window.location.reload();
    return;
  }
  
  // İlk yükleme veya aynı hash
  if (!storedHash) {
    sessionStorage.setItem('app_build_hash', currentHash);
  }
};

// Version kontrolünü çalıştır
checkVersion();

// Native (iOS/Android) platform başlatma (web'de etkisiz)
initNativePlatform();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);